import  types from "../actions/actionTypes";
import initialState from "./initialState";

const milestoneTemplatesReducer = (state = initialState.milestoneTemplates, action) => {

    const mergeInMilestoneTemplate = (milestoneTemplates, milestoneTemplateUpdate) => {
        const milestoneTemplatesMinusStaleData = milestoneTemplates.filter(milestoneTemplate => milestoneTemplate.id !== milestoneTemplateUpdate.id);       
        return milestoneTemplatesMinusStaleData.concat(milestoneTemplateUpdate);
    }

     const deleteMilestoneTemplate = (current, id) => {
        return current.filter(milestoneTemplate => milestoneTemplate.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_MILESTONETEMPLATE_SUCCESS:
        case types.UPDATED_MILESTONETEMPLATE_SUCCESS:
            return mergeInMilestoneTemplate(state, action.milestoneTemplate);
            case types.DELETED_MILESTONETEMPLATE:      
            return deleteMilestoneTemplate(state, action.id);      
        case types.DELETED_MILESTONETEMPLATE_INCOMING:  
        case types.UPDATED_MILESTONETEMPLATE_INCOMING:
            return deleteMilestoneTemplate(state, action.payload);    
        default:
            return state;
    }
}

export default milestoneTemplatesReducer;